module.exports = __webpack_public_path__ + "static/media/clock.de7c87eb.svg";